import { render, staticRenderFns } from "./AllTeamsStandingTournament.vue?vue&type=template&id=0a4c9028"
import script from "./AllTeamsStandingTournament.vue?vue&type=script&lang=js"
export * from "./AllTeamsStandingTournament.vue?vue&type=script&lang=js"
import style0 from "./AllTeamsStandingTournament.vue?vue&type=style&index=0&id=0a4c9028&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports